import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import "./scroll-top-btn.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "1.5em",
    height: "1.5em",
  },
}));

function ScrollTopBtn(props) {
  const classes = useStyles();

  const [visible, setVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleVisibility = () => {
    if (!visible && window.pageYOffset > 250) {
      setVisible(true);
    } else if (visible && window.pageYOffset <= 251) {
      setVisible(false);
    }
  };
  window.addEventListener("scroll", toggleVisibility);

  return (
    <div className="scroll-to-top">
      <ArrowUpwardIcon
        className={`${classes.root} scrollTop`}
        onClick={scrollToTop}
        style={{ display: visible ? "flex" : "none" }}
      />
    </div>
  );
}

export default ScrollTopBtn;
